export const ModuleLabels = {
  delivery: 'Delivery',
  waste: 'Waste',
  default: 'No Label for Module'
}

export const DeliveryProductCertOptions = [
  'FSC Mix 70%',
  'FSC Mix 100%',
  'FSC Mix',
  'FSC',
  'PEFC Mix 70%',
  'PEFC Mix 100%',
  'PEFC Mix',
  'PEFC'
]

export const IMPERIAL_VOLUME_UNITS = [
  { name: 'CubicYard', label: 'cu yd' },
  { name: 'UsGallon', label: 'gal' },
  { name: 'CubicFoot', label: 'cf' },
  { name: 'BoardFoot', label: 'bf' }
]

export const IMPERIAL_WEIGHT_UNITS = [
  { name: 'Pound', label: 'lbs' },
  { name: 'ShortTon', label: 'ton' }
]

export const METRIC_VOLUME_UNITS = [
  { name: 'CubicMeter', label: 'm3' },
  { name: 'Liter', label: 'l' },
  { name: 'ImperialGallon', label: 'gal' }
]

export const METRIC_WEIGHT_UNITS = [
  { name: 'Tonne', label: 't' },
  { name: 'Kilogram', label: 'kg' }
]

export const MeasurementUoM = [
  { name: 'Millimeter', label: 'mm' },
  { name: 'Meter', label: 'm' },
  { name: 'Foot', label: 'ft' },
  { name: 'Inch', label: 'in' }
]

export const ConvertToMetersObject = {
  Meter: 1,
  Millimeter: 0.001,
  Foot: 0.3048,
  Inch: 0.0254
}
